'use client';

import { useState } from 'react';
import { Typography, Box, Button } from '@mui/material';
import Container from '@/components/layout/Container';
import Section from '@/components/Section';
const texts = {
  desc: 'کرادفاندینگ (Crowdfunding) یا تامین سرمایه جمعی، راهی برای جمع‌آوری پول به‌منظور تامین مالی پروژه‌ها و مشاغل از طریق سرمایه‌گذاری گروهی است. در روش کرادفاندینگ، پروژه‌ها به‌جای این که صرفاً به دنبال سرمایه‌های بزرگ باشند، روی جذب تعداد زیادی سرمایه‌ی کوچک تمرکز می‌کنند. به کمک تامین مالی جمعی، کارآفرینان می‌توانند به جمع‌آوری پول برای یک کسب‌وکار یا توسعه‌ی یک محصول جدید اقدام نمایند.',
  btnTitle: 'دیدن بیشتر',
  btnTitleLess: 'دیدن کمتر'
};
const CrowdfundingSeoBox = (): JSX.Element => {
  const [showMore, setShowMore] = useState<boolean>(false);
  const handleShowMore = () => {
    setShowMore(!showMore);
  };
  return <Container data-sentry-element="Container" data-sentry-component="CrowdfundingSeoBox" data-sentry-source-file="CrowdfundingSeoBox.tsx">
      <Section alignItems='center' id='crowdfunding' data-sentry-element="Section" data-sentry-source-file="CrowdfundingSeoBox.tsx">
        <Typography typography='bodyLargeRegular__Wallfund' color='text.text' component='div' sx={{
        lineHeight: '40px'
      }} data-sentry-element="Typography" data-sentry-source-file="CrowdfundingSeoBox.tsx">
          <h2>کرادفاندینگ (Crowdfunding) یا تامین سرمایه جمعی چیست؟</h2>
          <p>
            کرادفاندینگ (Crowdfunding) یا تامین سرمایه جمعی، راهی برای جمع‌آوری
            پول به‌منظور تامین مالی پروژه‌ها و مشاغل از طریق سرمایه‌گذاری گروهی
            است. در روش کرادفاندینگ، پروژه‌ها به‌جای این که صرفاً به دنبال
            سرمایه‌های بزرگ باشند، روی جذب تعداد زیادی سرمایه‌ی کوچک تمرکز
            می‌کنند. به کمک تامین مالی جمعی، کارآفرینان می‌توانند به جمع‌آوری
            پول برای یک کسب‌وکار یا توسعه‌ی یک محصول جدید اقدام نمایند.
          </p>
        </Typography>

        <Typography typography='bodyLargeRegular__Wallfund' color='text.text' sx={{
        lineHeight: '40px',
        display: showMore ? 'unset' : 'none'
      }} component={'div'} data-sentry-element="Typography" data-sentry-source-file="CrowdfundingSeoBox.tsx">
          <h2>مزایای تامین مالی جمعی برای سرمایه‌گذاران</h2>
          <p>
            کرادفاندینگ یک روش نوآورانه برای تامین مالی محسوب می‌شود.
            سرمایه‌گذاری جمعی برای سرمایه‌گذاران و همچنین استارت‌آپ‌ها دارای
            مزایای مختلف است. استارت‌آپ با استفاده از این روش می‌تواند از
            مزایایی مانند ساخت مخاطب، دریافت بازخورد محصول قبل از راه‌اندازی
            رسمی و ریسک کمتر بهره‌مند شود. علاوه‌بر این موارد، تامین مالی جمعی
            مزایای مهمی نیز برای سرمایه‌گذاران دارد که عبارت‌اند از:
          </p>
          <Box component='ul' sx={{
          px: '15px'
        }} data-sentry-element="Box" data-sentry-source-file="CrowdfundingSeoBox.tsx">
            <li>امکان سرمایه‌گذاری با مبالغ کم یا زیاد</li>
            <li>دسترسی به پروژه‌های مختلف برای سرمایه‌گذاری</li>
            <li>شفافیت و امنیت بالای پروژه‌های سرمایه‌گذاری</li>
            <li>بازدهی مناسب</li>
            <li>کمک به ایجاد اشتغال</li>
          </Box>

          <h2>انواع مدل‌های تامین مالی جمعی</h2>
          <p>
            کرادفاندینگ دارای چهار نوع اصلی است که استارت‌آپ‌ها می‌توانند از بین
            آن‌ها مناسب‌ترین گزینه را با توجه به اولویت‌ها و شرایط خود انتخاب
            کنند:
          </p>

          <h3>تامین مالی جمعی مبتنی بر پاداش (Reward-Based Crowdfunding)</h3>
          <p>
            تامین مالی جمعی مبتنی بر پاداش یک روش محبوب برای جمع آوری سرمایه
            به‌ویژه برای پروژه‌های خلاقانه یا عرضه محصول جدید است. در این روش،
            سرمایه‌گذاران در ازای دریافت پاداش، به استارت‌آپ کمک می‌کنند.
            مهم‌ترین مزیت این روش این است که بر خلاف روش کرادفاندینگ مبتنی بر
            سهام، تمام مالکیت پروژه متعلق به صاحب پروژه است.
          </p>

          <h3>تامین مالی جمعی مبتنی بر سهام (Equity-Based Crowdfunding)</h3>
          <p>
            در این طرح سرمایه‌گذاری جمعی، سرمایه‌گذاران در ازای دریافت سهام شرکت
            به استارت‌آپ کمک می‌کنند. این مدل، سرمایه‌گذاران را در سود آینده‌ی
            شرکت شریک می‌کند و به همین دلیل در استارت‌آپ‌هایی با پتانسیل رشد
            بالا استفاده می‌شود. یکی از مهم‌ترین مزایای این مدل سرمایه گذاری
            جمعی، امکان جذب سرمایه‌ی بیشتر نسبت به کرادفاندینگ مبتنی بر پاداش
            است.
          </p>

          <h3>تامین مالی جمعی مبتنی بر بدهی (Debt-based Crowdfunding)</h3>
          <p>
            کرادفاندینگ مبتنی بر بدهی که با عنوان وام همتا به همتا (P2P lending)
            نیز شناخته می‌شود، یک وام مشابه وام‌های عادی است. تفاوت این روش با
            وام سنتی این است که به‌جای دریافت وام از بانک، وام از تعداد زیادی
            سرمایه‌گذار دریافت می‌شود. در این طرح، استارت‌آپ مبلغ سرمایه‌گذاری و
            سود آن را باید در مدت‌زمان مشخص به سرمایه‌گذاران بازگرداند. از
            مزایای این مدل می‌توان به حفظ مالکیت پروژه بر استارت‌آپ و برنامه
            بازپرداخت مشخص اشاره کرد.
          </p>

          <h3>کرادفاندینگ مبتنی بر کمک مالی (Donation-Based Crowdfunding)</h3>
          <p>
            سرمایه گذاری جمعی مبتنی بر کمک مالی، روشی است که دریافت پاداش یا
            سهام را برای سرمایه‌گذار در پی ندارد. این روش برای پروژه بسیار عالی
            است؛ به این دلیل که کسب‌وکار مورد نظر هیچ‌گونه نگرانی بابت پرداخت
            پاداش یا بخشی از سهام خود ندارد.
          </p>

          <h2>طرح‌های سرمایه‌گذاری جمعی چطور انتخاب می‌شوند؟</h2>
          <p>
            انتخاب طرح سرمایه‌گذاری جمعی برای یک استارت‌آپ، بیشتر از هر چیز به
            اهداف پروژه و ماهیت کسب‌وکار بستگی دارد. با این حال فاکتورهای مهم
            دیگری نیز در انتخاب طرح‌های کرادفاندینگ اثرگذار هستند از جمله:
          </p>
          <Box component='ul' sx={{
          px: '15px'
        }} data-sentry-element="Box" data-sentry-source-file="CrowdfundingSeoBox.tsx">
            <li>
              <strong>نوع سود مورد انتظار (Expected profit):</strong>{' '}
              سرمایه‌گذاران می‌توانند بر اساس نوع سود موردنظر خود، در پروژه‌های
              کرادفاندینگ شرکت کنند. افرادی که به دنبال پاداش نقدی هستند،
              می‌توانند از سرمایه‌گذاری‌های جمعی مبتنی بر پاداش یا کرادفاندینگ
              مبتنی بر بدهی، استفاده کنند؛ اما اگر هدف از سرمایه‌گذاری، دریافت
              سهام یک پروژه یا استارت‌آپ باشد، کرادفاندینگ مبتنی بر سهام گزینه
              مناسبی است.
            </li>
            <li>
              <strong>میزان ریسک (Risk):</strong> طرح‌های سرمایه‌گذاری جمعی،
              دارای سطح ریسک متفاوتی هستند. به عنوان مثال در تامین مالی مبتنی بر
              سهام، به دلیل اینکه سرمایه‌گذار در معرض سهام یک پروژه قرار
              می‌گیرد، میزان سودآوری او به موفقیت یا عدم موفقیت پروژه بستگی
              دارد. در مقابل، طرح‌های تامین مالی مبتنی بر پاداش، دارای سود مشخصی
              بوده و ریسک اندکی دارند.
            </li>
            <li>
              <strong>
                ماهیت کسب و کار یا پروژه (Nature of business or project):
              </strong>{' '}
              اگر پروژه به‌دنبال راه‌اندازی محصول یا خدمات جدید باشد، احتمالا
              سرمایه‌گذاری جمعی مبتنی بر پاداش بهترین گزینه است. همچنین اگر
              پروژه یک کسب‌وکار در حال گسترش است، سرمایه‌گذاری جمعی مبتنی بر
              سهام می‌تواند گزینه‌ای عالی باشد.
            </li>
            <li>
              <strong>
                نیازها و اهداف مالی (Financial needs and objectives):
              </strong>{' '}
              برای جذب مبالغ بزرگ‌تر، سرمایه‌گذاری جمعی مبتنی بر بدهی یا سهام
              ممکن است مناسب‌تر باشد. همچنین برای جذب سرمایه کمتر، سرمایه‌گذاری
              جمعی مبتنی بر پاداش یا کمک مالی می‌تواند مناسب باشد.
            </li>
            <li>
              <strong>اعتبارسنجی بازار (Market validation):</strong>{' '}
              سرمایه‌گذاری جمعی مبتنی بر پاداش، می‌تواند بازخورد مناسبی نسبت به
              محصول را ارائه دهد.
            </li>
            <li>
              <strong>مالکیت و کنترل (Ownership and control):</strong> اگر
              به‌عنوان یک صاحب پروژه حفظ کنترل کامل و مالکیت استارت‌آپ برای شما
              مهم است، سرمایه‌گذاری جمعی مبتنی بر پاداش، کرادفاندینگ مبتنی بر
              کمک مالی یا تامین مالی جمعی مبتنی بر بدهی گزینه‌های مناسبی برای
              شما هستند.
            </li>
          </Box>

          <h2>مقایسه بازدهی سرمایه‌گذاری جمعی با سایر بازارهای مالی</h2>
          <p>
            مقایسه بازدهی کرادفاندینگ با سایر بازارهای مالی می‌تواند پیچیده
            باشد؛ زیرا هر یک از روش‌های سرمایه‌گذاری دارای ویژگی‌ها، مزایا و
            معایب خاص خود هستند. برای مثال سرمایه‌گذاری در بازار املاک، یک
            سرمایه‌گذاری با ریسک پایین است که البته مبلغ سرمایه‌گذاری بالایی را
            نیاز دارد. در مقایسه با بازار سهام نیز می‌توان گفت کرادفاندینگ و
            بازار سهام هر دو می‌توانند بازدهی بالایی داشته باشند، اما ریسک آن‌ها
            متفاوت است.
          </p>

          <p>
            در کرادفاندینگ به دلیل تضامین بانکی که به متقاضی اعطا می‌شود، اصل
            سرمایه تضمین شده است و حتی در صورت نوسان شدید بازار یا نرخ ارز، خطری
            متوجه مبلغ اولیه هر فرد نیست. در صورتی که در سایر روش‌های
            سرمایه‌گذاری (مثل سهام، صندوق‌های سرمایه‌گذاری و غیره) در شرایط ریزش
            بازار، سرمایه اولیه هم با ریسک کاهش ارزش همراه است.
          </p>

          <h2>نقش کرادفاندینگ در توسعه اقتصاد</h2>
          <p>
            بدون شک توسعه فضای کسب و کار نقش مهمی در رشد اقتصاد و فقرزدایی در
            کشور دارد. کرادفاندینگ باعث رشد سرمایه‌گذاری در پروژه‌ها و ایده‌های
            خلاقانه می‌شود و به کسب و کارها و پروژه‌های کوچک و بزرگ کمک می‌کند
            که منابع مالی لازم برای شروع و توسعه فعالیت خود را بدون نیاز به
            سرمایه‌گذاری‌های بزرگ یا بدهی‌های بانکی به‌دست آورند. بدون تردید،
            کرادفاندینگ به عنوان ابزاری قانونی و در دسترس، به جهت نظارت مستقیم
            مردم و شفافیت حاکم بر آن، بهترین راهکار برای تجمیع و تزریق منابع
            مالی غیرمتمرکز در بدنه اقتصاد کشور است.
          </p>
        </Typography>

        <Button variant='text' sx={{
        width: 'fit-content',
        typography: 'bodyLargeMedium__Wallfund'
      }} onClick={handleShowMore} className='p' data-sentry-element="Button" data-sentry-source-file="CrowdfundingSeoBox.tsx">
          {showMore ? texts.btnTitleLess : texts.btnTitle}
        </Button>
      </Section>
    </Container>;
};
export default CrowdfundingSeoBox;